import { render, staticRenderFns } from "./IncidentTab.vue?vue&type=template&id=45c542d8"
import script from "./IncidentTab.vue?vue&type=script&lang=js"
export * from "./IncidentTab.vue?vue&type=script&lang=js"
import style0 from "./IncidentTab.vue?vue&type=style&index=0&id=45c542d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports